export default "__VITE_ASSET__C58rn1Ip__"